import React, { useRef, useState } from "react";
import "../supplierAndManufacturers.scss";
import SortingHeaderComponent from "../../../Common/SearchFilterComponent/SortingHeaderComponent";

const HeaderList = [{
  id: 0,
  label: 'Company'
},
{
  id: 1,
  label: 'Type'
},
{
  id: 2,
  label: 'Status'
},
{
  id: 3,
  label: 'Categories'
},
{
  id: 4,
  label: 'Subcategories'
},
{
  id: 5,
  label: 'Spend (Last 12m)'
}]

const BodyHeader = ({
  headersList = [],
  sortOrder = 0,
  setSortOrder = () => { },
  getMSPAllSupplierManufacturer = () => { },
  setHeadersList = () => { },
}) => {
  const [sortData, setSortData] = useState({ sortItem: 0, sortOrder: 0, sorting: false });

  // function sortRecords(_fieldKey) {
  //   console.log('_fieldKey', _fieldKey)
  //   let _sortOrder = 0;
  //   if (sortData.sortItem === _fieldKey) {
  //     _sortOrder = sortData.sortOrder === 0 ? 1 : 0;
  //   } else {
  //     _sortOrder = 0;
  //   }

  //   setSortData({ sortItem: _fieldKey, sortOrder: _sortOrder, sorting: true });
  //   setSortData({ sortItem: _fieldKey, sortOrder: _sortOrder, sorting: false });
  // }


function sortRecords(_fieldKey) {
  console.log('_fieldKey', _fieldKey);

  const isSameField = sortData.sortItem === _fieldKey;
  const newSortOrder = isSameField ? (sortData.sortOrder === 0 ? 1 : 0) : 0;

  setSortData({ sortItem: _fieldKey, sortOrder: newSortOrder, sorting: true });
}

  return (
    <div className="tableHeader suppliersAndManufacturersTable">
      {headersList?.map((headerItem, headerItemIndex) => {
        return (
          <>
            {headerItem?.Visibility === true && (
              <SortingHeaderComponent
                headerName={headerItem?.FieldName}
                headerKey={headerItem?.FieldKey}
                selectedHeaderItemStyle={'bg-transparent'}
                labelStyle={'f-grey'}
                sortData={sortData}
                onSortClick={() => {
                  console.log('headerItem?.FieldKey', headerItem?.FieldKey)
                  sortRecords(headerItem?.FieldKey)
                  setSortOrder(sortOrder === 0 ? 1 : 0);
                  getMSPAllSupplierManufacturer({ sortOrder: sortOrder === 0 ? 1 : 0 });
                }}
                updatedHeaderList={() => {
                  const updatedData = headersList.map(item => {
                    if (item?.FieldKey === headerItem?.FieldKey) {
                      return { ...item, Visibility: false };
                    }
                    return item;
                  });
                  getMSPAllSupplierManufacturer({ visibilityList: JSON.stringify(updatedData), number: 0 });
                  setHeadersList(updatedData);
                }}
              />
            )}
          </>
        );
      })}
    </div>
  );
};

export default BodyHeader;
